import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import useAuthStore from '../store/useAuthStore';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateUser, user } = useAuthStore();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(() => {
        setStatus('success');
        if (user) updateUser({ ...user, emailVerified: true });
        setTimeout(() => navigate('/home'), 3000);
      })
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col items-center justify-center px-6 text-center">
      {status === 'verifying' && (
        <>
          <div className="w-12 h-12 border-4 border-brand-purple border-t-transparent rounded-full animate-spin mb-6" />
          <p className="text-dark-text font-semibold text-lg">Verifying your email…</p>
        </>
      )}
      {status === 'success' && (
        <>
          <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mb-6">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-dark-text mb-2">Email Verified!</h1>
          <p className="text-dark-subtext">Redirecting you to the app…</p>
        </>
      )}
      {status === 'error' && (
        <>
          <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mb-6">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-dark-text mb-2">Invalid Link</h1>
          <p className="text-dark-subtext mb-6">This verification link is invalid or has expired.</p>
          <button
            onClick={() => navigate('/home')}
            className="px-6 py-3 rounded-2xl bg-brand-gradient text-white font-semibold"
          >
            Go to App
          </button>
        </>
      )}
    </div>
  );
}
